import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getNewsletterUpdateProgress,
    stopNewsletterBulkUpdate,
    usersNewsletterBulkUpdate,
} from 'src/openapi/admin/apis/UserNewsletterBulkUpdateApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UpdateUserNewsletterModal} from './update-user-newsletter.modal';
import {
    selectUpdateNewslettersBulkUuid,
    selectUpdateNewslettersTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './update-user-newsletter.slice';

import type {UpdateUserNewsletter} from 'src/openapi/admin/models/UpdateUserNewsletter';

type Props = {
    shown: boolean,
    userIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const UpdateUserNewsletterTool = ({shown, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UpdateUserNewsletter>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}
            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateNewslettersTask}
            uuidSelector={selectUpdateNewslettersBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(updateUserNewsletter, options) => (
                apiDispatch(usersNewsletterBulkUpdate({...options, updateUserNewsletter}))
            )}
            getProgress={id => apiDispatch(getNewsletterUpdateProgress({id}))}
            stopAction={id => apiDispatch(stopNewsletterBulkUpdate({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateUserNewsletterModal {...{userIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
